// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Vr","prevArrow":"Wr","nextArrow":"Xr","disabled":"Yr","borderedArrow":"Zr"};